import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import user from './userGateway/user'
import consents from './iyspanelGateway/consents'
import { NotificationProgrammatic as Notification } from 'buefy'
import i18n from '../i18n.js'
import router from '../router'


Vue.use(Vuex)

axios.interceptors.response.use(function (response) {
    console.log("--vuex interceptor response--")
    console.log(response)
    try {
        if(response.data.status.code=='-2'){
            router.push('/login').catch(()=>{})
        }else if(response.data.status.code!=='0'){
            Notification.open({
                duration: 5000,
                message: `${i18n.t(response.data.status.desc)}`,
                position: 'is-top-right',
                type: 'is-danger',
                hasIcon: true
            })
        }
    } catch (error) {
        console.log("--vuex interceptor response error--")
        console.log(error)
    }
    
    return response;

},function (error) { return Promise.reject(error); });

const state={
    baseUrl:process.env.API_URL
}

const getters={
    
}
const mutations={
    
}
const actions={
    
}
const modules={
    user,
    consents
}

const store = new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    modules
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js